import { Component, inject, input, InputSignal, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { take } from 'rxjs';
import { AmlScanEntity, LatestAmlReport, IngoingTransaction } from '../../../../../../../api/api.model';
import { ApiService } from '../../../../../../../api/api.service';
import { AuthService } from '../../../../../../services/auth.service';
import { VariablesService } from '../../../../../../services/variables.service';
import { NgOptimizedImage, DatePipe, LowerCasePipe, DecimalPipe, TitleCasePipe, NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { ConvertNetworkToTokenPipe } from '../../../../../../pipes/convert-netwrok-to-token.pipe';
import { CropWithDotsCenterPipe } from '../../../../../../pipes/crop-with-dots-center.pipe';
import { CopyButtonComponent } from '../../../../../copy-button/copy-button.component';
import { CutNumberPipe } from "../../../../../../pipes/cut-number.pipe";

@Component({
  selector: 'app-lea-short-report',
  imports: [
    NgOptimizedImage,
    DatePipe,
    CopyButtonComponent,
    LowerCasePipe,
    ConvertNetworkToTokenPipe,
    CropWithDotsCenterPipe,
    MatSelectModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatButtonModule,
    CutNumberPipe
],
  templateUrl: './lea-short-report.component.html',
  styleUrl: './lea-short-report.component.scss'
})
export class LeaShortReportComponent implements OnInit {
  readonly transactionInput: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();


  readonly transaction = signal<AmlScanEntity<LatestAmlReport> | null>(null);
  readonly listTypeBlock = signal<string[]>([]);
  readonly isLoading = signal<boolean>(false);
  readonly isOpenTrigger = signal<boolean>(false);
  limitedMinDate: Date = new Date();
  readonly variablesService: VariablesService = inject(VariablesService);
  private readonly _apiService: ApiService = inject(ApiService);
  readonly authService: AuthService = inject(AuthService);


  ngOnInit(): void {
    this.transaction.set(this.transactionInput());
    const transaction = this.transaction();
    console.log(transaction);
  }

  loadTransaction(): void {
    const transactionUuid = this.transaction()?.uuid;
    if (transactionUuid) {
      this._apiService.getAmlScanByUuid(transactionUuid).pipe(take(1)).subscribe({
        next: (data: AmlScanEntity) => {
        const transaction = {
          ...data,
          latestAmlReport: JSON.parse(data.latestAmlReport)
        }
          this.transaction.set(transaction);
        }
      })
    }
  }

  asIngoingTransaction(transaction: AmlScanEntity<LatestAmlReport>): AmlScanEntity<IngoingTransaction> {
    return transaction as AmlScanEntity<IngoingTransaction>;
  }
}
